import { useGetAccentraStatus } from '@/api/property-keyless/accentra/get-accentra-status'

import { AccentraConnectionFormValues, accentraDefaultValues } from './accentra.schema'

// Note: the status endpoint only reports connected/disconnected (`{ isConnected }`) — it
// doesn't echo back `login`/`password` (write-only admin credentials), so the form never
// pre-fills them even when Active, same treatment as `authorizationCode` for BMX/RemoteLock.
export const useAccentraConnection = (buildingId: number) => {
  const { data, isLoading, isSuccess } = useGetAccentraStatus({ buildingId })
  const values: AccentraConnectionFormValues = accentraDefaultValues

  return { isConfigured: isSuccess && Boolean(data?.isConnected), isLoading, values }
}
